const handlerRef = {
  current: (url, init) => [url, init]
};

/**
 * tiny utility to enrich authenticate requests to the UserData backend (based
 * on the fetch request signature)
 *
 * this implementation will allow custom implementation of the authentication
 * method on a per-application basis, which enables pure frontend-integrations
 * to rely on the gProxy implementation and backend-integrations to provide
 * custom authentication
 *
 * @example
 * ```ts
 * const res = await fetch(...authenticateComponentFrameworkRequest(requestUrl, requestInit));
 * ```
 */
const authenticateComponentFrameworkRequest = Object.assign(function authenticateComponentFrameworkRequest(...args) {
  return handlerRef.current(...args);
}, {
  intercept(handler) {
    handlerRef.current = handler;
  }
});

export { authenticateComponentFrameworkRequest };
//# sourceMappingURL=util.authenticate-component-framework-request.js.map
